import React from 'react';
import G from "./libs/Glob.mjs";
import appLib from "./libs/appLib.mjs";
import Login from "./components/login/Login.mjs";
import HermesLogo from "./media/images/HermesLogo.mjs";
import "./media/css/App.css";
import AppHeader from "./components/header/AppHeader.mjs";
import ListLibraries from "./components/ListLibraries.mjs";
import NewLibrary from "./components/NewLibrary.mjs";
import EditLibrary from "./components/EditLibrary.mjs";

const prefix="App";

const App = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			curPage: G.getCurrentPage(),
			username: G.getUserLoginName()
		};
		this.uid = G.generateUid(prefix);
		this.verifyLogin = this.verifyLogin.bind(this);
		this.renderPanel = this.renderPanel.bind(this);
	}

	componentDidMount() {
		G.register('currentPage', cp => {
			this.setState({curPage: cp});
		}, this.uid);
		G.register('userLogin', this.verifyLogin, this.uid);
		appLib.login().then(this.verifyLogin);
	}

	componentWillUnmount() {
		G.deregister(this.uid);
	}

	renderPanel(cp) {
		if (!this.state.username && !this.state.loggingIn) {
			setTimeout(this.verifyLogin);
			return "";
		}
		switch (cp.name) {
			case 'ListLibraries': return <ListLibraries {...cp.params} />;
			case 'NewLibrary': return <NewLibrary {...cp.params} />;
			case 'EditLibrary': return <EditLibrary {...cp.params} />;
			case 'Login': return <Login {...cp.params} />;
			default:
				return <ListLibraries {...cp.params} />;
		}
	}

	verifyLogin() {
		const u = G.getUserLoginName();
		let alp = this.state.afterLoginPage || this.state.curPage;
		if (alp?.name === 'Login') alp = G.getHomePage(true);
		if (u) {
			const ns = {username: u, afterLoginPage: undefined, loggingIn: undefined};
			this.setState(ns, () => {
				G.gotoPage(alp, true);
			});
		} else if (!this.state.loggingIn) {
			const ns = {username: undefined, loggingIn: true};
			if (!this.state.afterLoginPage) ns.afterLoginPage = alp;
			this.setState(ns, () => {
				G.gotoPage('Login');
			});
		}
	}

	render() {
		return (
			<div className={prefix}>
				<div className={"AppMainBackground"}>
					<HermesLogo />
				</div>
				<AppHeader/>
				<div className={"AppContent"} key={this.state.curPage?.name}>
					{this.renderPanel(this.state.curPage)}
				</div>
			</div>
		);
	}
}

export default App;
